import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DoctorAppointment, EAppointmentState } from 'src/app/entities/appointment.entity';
import { ConsultationMotif } from 'src/app/entities/consultation.entity/consultation-motif.entity/consultation-motif';
import { EDalyTimeSlotLocation } from 'src/app/entities/daly-time-slot.entity/daly-time-slot';
import { DoctorAvailability } from 'src/app/entities/doctor-disponiblity.entity/doctor-availability';
import { DoctorPatient } from 'src/app/entities/doctor-patient.entity/doctor-patient';
import { Doctor } from 'src/app/entities/user.entity/doctor.entity';
import { AuthService } from 'src/app/services/auth.service/auth.service';
import { DoctorAppointmentService } from 'src/app/services/doctor-appointments.service/doctor-appointments.service';

@Component({
  selector: 'app-update-rendez-vous-shared',
  templateUrl: './update-rendez-vous.component.html',
  styleUrls: ['./update-rendez-vous.component.css']
})
export class UpdateRendezVousComponent implements OnInit {

  @Input() doctorPatients: Array<DoctorPatient> = new Array();
  @Input() userTarget!: DoctorPatient;
  @Input() location: EDalyTimeSlotLocation = EDalyTimeSlotLocation.ATSITE;
  @Input() disponibilites: Array<DoctorAvailability> = new Array();
  @Input() disponibiliteDefalut: number = 0;
  @Input() disponibilite: DoctorAvailability | any = new DoctorAvailability({});
  @Input() doctorAppointment: DoctorAppointment = new DoctorAppointment({
    status: EAppointmentState.PENDING,
    motif: "Consultation Régulière",
  });
  @Input() assistanceId: string = "";
  @Input() consultationMotifs: Array<ConsultationMotif> = [];
  @Input() date: string = "";
  @Input() dateDisponibilte!: Date;
  constructor(
    private doctorAppointmentsService: DoctorAppointmentService,
    private authservice: AuthService,
    private toastrService: ToastrService,
  ) { }
  @Input() creationPatient: boolean = false;
  @Output() creationPatientChange: EventEmitter<boolean> = new EventEmitter();
  @Output() close: EventEmitter<void> = new EventEmitter();
  @Output() refreshData: EventEmitter<void> = new EventEmitter()
  @Input() filter: boolean = false
  changeValueDisponibilte: boolean = false;
    heureInput: string = "";

  usersList: any[] = [];
  selectedUser: any;

  // ✅ couleur principale
  selectedColor: string = '';
  get doctor(): Doctor {
    return this.authservice.getCurrentUser() as Doctor;
  }
colors = [
  { value: "#FADADD", color: "rose clair" },     // 🌸 Rose clair
  { value: "#B8E994", color: "vert pastel" },    // 🌿 Vert pastel
  { value: "#FFF9B0", color: "jaune clair" },    // ☀️ Jaune clair
  { value: "#A8D8EA", color: "bleu ciel doux" }, // 🌊 Bleu ciel
  { value: "#FFDAB9", color: "pêche" },          // 🍑 Pêche
  { value: "#E6E6FA", color: "lavande" },        // 💜 Lavande
  { value: "#DFFFBF", color: "vert pomme clair"},// 🍏 Vert pomme clair
  { value: "#F5F5DC", color: "beige doux" },     // 🌼 Beige doux
  { value: "#BFD7ED", color: "bleu pastel" },    // 🩵 Bleu pastel
  { value: "#FFB6B9", color: "corail clair" }    // 🌷 Corail clair
];


  
  isOpen = false;

toggleDropdown() {
  this.isOpen = !this.isOpen;
}

selectColor(color: string) {
  this.doctorAppointment.colorCode = color;
  this.isOpen = false;
  this.isOpen = !this.isOpen;
}

  ngOnInit(): void {

    this.filter == false ? this.changeValueDisponibilte = false : this.changeValueDisponibilte = true
   this.changeValueDisponibilte = this.filter;
    this.heureInput = this.msToTime(this.disponibilite.startTime);
this.location = this.doctorAppointment.location;
    this.getAssistants();

    this.disponibiliteDefalut = this.disponibilite.startTime;  }
trackById(index: number, item: any) {
  return item.id;
}
  ngOnChanges() {
    this.heureInput = this.msToTime(this.disponibilite.startTime);
this.location = this.doctorAppointment.location;
    if (this.usersList.length && this.doctorAppointment?.assistantId) {
      this.selectedUser = this.usersList.find(
        u => u.id === this.doctorAppointment.assistantId
      );

      // ✅ init couleur depuis backend
      this.selectedColor = this.doctorAppointment.assistanceColorCode || this.doctorAppointment.colorCode;
    }
  }

  getAssistants() {
    this.doctorAppointmentsService.getAssistantList().subscribe({
      next: (res: any) => {

        const medecin = { ...res.medecin, type: 'DOCTOR' };

        const assistants = res.assistants.map((a: any) => ({
          ...a,
          type: 'ASSISTANT'
        }));

        this.usersList = [medecin, ...assistants];

        // ✅ init selected user
        this.selectedUser = this.usersList.find(
          u => u.id === this.doctorAppointment.assistantId
        ) || null;
        
this.location=this.doctorAppointment.location;
        // ✅ init couleur
        this.selectedColor = this.doctorAppointment.assistanceColorCode || this.doctorAppointment.colorCode || '#FADADD';
      }
    });
  }
 msToTime(ms: number): string {
    const totalSeconds = Math.floor(ms / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);

    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  }
  // ✅ comparer objets select
  compareUsers(u1: any, u2: any): boolean {
    return u1 && u2 ? u1.id === u2.id : u1 === u2;
  }



  // ✅ changement user → update couleur
  onUserChange() {
    if (this.selectedUser) {
      this.selectedColor = this.selectedUser.colorCodeAct || '#FADADD';
      this.doctorAppointment.colorCode = this.selectedColor;
      
    }
  }

  refresh(event: DoctorPatient) {
    this.userTarget = event;
    this.refreshData.emit()

  }
  change(event: any) {
    this.changeValueDisponibilte = event.isTrusted;
  }
  sumbit() {


    const dateStr = this.date;
    const [day, month, year] = dateStr.split("/").map(Number);
    const date = new Date(year, month - 1, day);

    this.doctorAppointment.date = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    );
    console.log("Submitting appointment update:", this.doctorAppointment, this.disponibilite, this.date);

     this.doctorAppointment.startTime = this.disponibilite.startTime != 0 ? this.disponibilite.startTime : this.disponibilite.startTime = this.doctorAppointment.startTime
    this.doctorAppointment.duration = this.doctorAppointment.duration;

    if (this.userTarget !== undefined) {
      this.doctorAppointmentsService.update(this.doctorAppointment.id, this.doctorAppointment).subscribe((res: any) => {
        this.toastrService.success("Rdv mis à jour");
        this.doctorAppointment = new DoctorAppointment({});
        this.refreshData.emit()

        this.changeValueDisponibilte = false;
        this.userTarget = new DoctorPatient();
        this.close.emit();

      });

    } else {
    }
  }
  onTimeChange(event: any) {
    const value = event.target.value;

    if (!value) {
      this.disponibilite.startTime = 0;
      return;
    }

    const [hours, minutes] = value.split(":").map(Number);

    const milliseconds =
      (hours * 60 * 60 * 1000) +
      (minutes * 60 * 1000);


    this.disponibilite.startTime = milliseconds;
    this.disponibiliteDefalut =milliseconds
  }
}
